import { render, staticRenderFns } from "./SelectTableColumns.vue?vue&type=template&id=04b9fc3b&scoped=true&"
import script from "./SelectTableColumns.vue?vue&type=script&lang=ts&"
export * from "./SelectTableColumns.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTableColumns.vue?vue&type=style&index=0&id=04b9fc3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9fc3b",
  null
  
)

export default component.exports